import { FC } from 'react'

const AmexIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="5"
      fill="#0193CE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8692 15.8953H26.8329L28.3486 14.1482L30.0147 15.8953H31.7734L29.2279 13.4655L31.7849 10.8391H30.0263L28.3601 12.5862L26.9023 10.8507H21.8808V9.86719H27.2957L28.3601 11.2325L29.6213 9.86719H34.3072L30.7899 13.4655L34.3072 16.8672H29.6213L28.3486 15.5135L27.2841 16.8672H21.8692V15.8953ZM26.1155 14.9234H23.1882V13.9515H25.9188V12.9912H23.1882V12.0193H26.3122L27.4808 13.4771L26.1155 14.9234ZM9.33865 16.8672H5.28906L8.72543 9.86719H11.9651L12.3701 10.6424V9.86719H16.4196L17.2296 11.811L18.0395 9.86719H21.8692V16.8672H18.8263V15.8953L18.4329 16.8672H16.0031L15.5982 15.8953V16.8672H11.1552L10.7502 15.7102H9.74361L9.33865 16.8672ZM20.8626 15.8953V10.8391H18.8494L17.2296 14.3449L15.5982 10.8391H13.5849V15.5135L11.1552 10.8391H9.53534L7.10559 15.8953H8.52873L8.93369 14.7383H11.5601L11.9651 15.8953H14.7767V12.0077L16.6279 15.8953H17.8428L19.6593 12.0077V15.8953H20.8626ZM11.1552 13.7548L10.3453 11.6143L9.33865 13.7548H11.1552Z"
      fill="white"
    />
  </svg>
)

export default AmexIcon
